export default "__VITE_ASSET__DQo9BgcX__"